module.exports = __webpack_public_path__ + "static/img/12.ee6cef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/12.jpg
// module id = 4iOq
// module chunks = 0